








import { defineComponent, PropType, ref } from "@vue/composition-api";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import BaseIcon from "@/components/BaseIcon";
import BaseSwitch from "@/components/BaseSwitch";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "MoreMenuItemNSFWUserSetting",
  components: { BaseSwitch, BaseIcon },
  props: {
    item: { type: Object as PropType<IMoreMenuItem>, required: true },
  },
  setup() {
    const { showNotSafeForWork, updateNSFWUserSettings } = useNSFWUserSettings();
    const showConfirm = ref(false);
    const processing = ref(false);

    const onClick = async () => {
      try {
        processing.value = true;
        await updateNSFWUserSettings(!showNotSafeForWork.value);
      } catch (e) {
      } finally {
        processing.value = false;
      }
    };

    return {
      processing,
      showConfirm,
      showNotSafeForWork,
      onClick,
    };
  },
});
